import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { LegacyOrderHook, LegacyOrderHookId } from '../legacy-order-hook.js';
import { OrderSideEffectType } from './order-side-effect-type.js';
import { OrderSideEffect } from './order-side-effect.js';

/**
 * @deprecated use [CreateMultiOpenAccessPassSideEffect] instead. This side effect is leftover from the legacy hook system.
 */
export class CreateSingleOpenAccessPassSideEffect extends OrderSideEffect {
  static readonly TYPE_ID: string = '247f14fd3af04ecda0acd3ad59581a46';

  public readonly effectType: OrderSideEffectType = OrderSideEffectType.CreateSingleOpenAccessPass;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return CreateSingleOpenAccessPassSideEffect.TYPE_ID;
  }

  static create(): CreateSingleOpenAccessPassSideEffect {
    return new CreateSingleOpenAccessPassSideEffect();
  }

  static fromMap(context: SerializationContext, map: SerializedData): CreateSingleOpenAccessPassSideEffect {
    return new CreateSingleOpenAccessPassSideEffect();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'effectType': fromEnumAsString(this.effectType),
    };
  }

  clone(): this {
    return new CreateSingleOpenAccessPassSideEffect() as this;
  }

  isSame(other: CreateSingleOpenAccessPassSideEffect): boolean {
    if(this === other) {
      return true;
    }

    return other.effectType === this.effectType;
  }

  toLegacyOrderHook(): LegacyOrderHook {
    return LegacyOrderHook.create(LegacyOrderHookId.CreateOpenAccessPass);
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CreateSingleOpenAccessPassSideEffect;
  }

  static assertType(order: DataModel): order is CreateSingleOpenAccessPassSideEffect {
    return order instanceof CreateSingleOpenAccessPassSideEffect;
  }
}

export class CreateSingleOpenAccessPassSideEffectBuilder extends DataModelBuilder<CreateSingleOpenAccessPassSideEffect> {
  build(context: SerializationContext, map: SerializedData): CreateSingleOpenAccessPassSideEffect {
    return CreateSingleOpenAccessPassSideEffect.fromMap(context, map);
  }
}
